<a
  class="agentic-product-card"
  [class.missing]="showNotSeenOverlay"
  [class.pdp-with-gaps]="isPdpPage && hasMissingComparisonFields"
  [class.no-link]="!productUrl"
  [attr.href]="productUrl || null"
  [attr.target]="productUrl ? '_blank' : null"
  [attr.rel]="productUrl ? 'noopener noreferrer' : null"
>
  <div class="product-image">
    <img
      *ngIf="imageUrl && !imageFailed"
      [src]="imageUrl"
      [alt]="productName"
      loading="lazy"
      (error)="onImageError()"
    />
    <div class="product-image-placeholder" *ngIf="!imageUrl || imageFailed">
      <mat-icon>image_not_supported</mat-icon>
    </div>
  </div>

  <div class="missing-overlay" *ngIf="showNotSeenOverlay">
    <mat-icon>visibility_off</mat-icon>
    <span>Not seen by {{ selectedAgentLabel }}</span>
  </div>

  <div class="product-details">
    <h4>{{ productName }}</h4>

    <div class="pdp-product-meta" *ngIf="hasPdpProductMeta">
      <span class="pdp-product-meta-item" *ngIf="ratingLabel">
        Rating {{ ratingLabel }}
      </span>
      <span class="pdp-product-meta-item" *ngIf="reviewCountLabel">
        {{ reviewCountLabel }}
      </span>
    </div>

    <div class="product-meta" *ngIf="price || availabilityText">
      <strong *ngIf="price">{{ price }}</strong>
      <span class="availability" *ngIf="availabilityText">
        {{ availabilityText }}
      </span>
    </div>

    <div class="comparison-gaps comparison-found" *ngIf="isPdpPage && hasFoundComparisonFields">
      <span class="comparison-gaps-title">Found fields</span>
      <div class="comparison-field-list">
        <span
          class="comparison-field found"
          *ngFor="let field of foundComparisonFields"
        >
          {{ formatComparisonField(field) }}
        </span>
      </div>
    </div>

    <div class="comparison-gaps" *ngIf="isPdpPage && hasMissingComparisonFields">
      <span class="comparison-gaps-title">Missing fields</span>
      <div class="comparison-field-list">
        <span
          class="comparison-field"
          *ngFor="let field of missingComparisonFields"
        >
          {{ formatComparisonField(field) }}
        </span>
      </div>
    </div>

    <div
      class="comparison-gaps comparison-status"
      *ngIf="isPdpPage && !hasComparisonData"
    >
      No comparison data for {{ selectedAgentLabel }}
    </div>

    <div
      class="comparison-gaps comparison-status"
      *ngIf="
        isPdpPage &&
        hasComparisonData &&
        !comparisonThresholdMet &&
        !hasMissingComparisonFields
      "
    >
      Comparison threshold not met
    </div>

    <span class="product-link-hint" *ngIf="productUrl && (visible || isPdpPage)">
      <mat-icon>open_in_new</mat-icon>
    </span>
  </div>
</a>
